<template>
  <div id="wrapper" class="page">
    <div id="content-wrapper" style="height: 100%;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#" @click.prevent>
            <span>
              Assets Report
              <!-- Báo cáo tài sản -->
            </span>
          </a>
        </li>
      </ol>
      <div class="container-fluid">
        <div class="form-inline">
          <button class="btn btn-info mb-2" @click.prevent="openModal">
            <i class="far fa-file-alt"></i>
            Select Report
            <!-- Chọn báo cáo -->
          </button>
          <div style="flex-grow: 1" class="text-center"></div>
          <button v-if="report != null" class="btn btn-success mr-2" @click.prevent="excelReport">
            <i class="far fa-file-excel"></i>
            Export Excel
            <!-- Xuất excel -->
          </button>
        </div>
        <report-asset-type
          v-if="report == 0"
          :tinhtrangtaisans="tinhtrangtaisans"
          :departments="departments"
          :assetType="assetType">
        </report-asset-type>
        <report-all-asset-type
          v-if="report == 1"
          :tinhtrangtaisans="tinhtrangtaisans"
          :vitricongviecs="vitricongviecs"
          :departments="departments"
          :rooms="rooms">
        </report-all-asset-type>
        <report-all-asset-type-by-type
          v-if="report == 2"
          :tinhtrangtaisans="tinhtrangtaisans"
          :departments="departments">
        </report-all-asset-type-by-type>
      </div>
    </div>
    <b-modal
      v-model="modalShow"
      header-bg-variant="primary"
      header-text-variant="light"
      hide-footer
    >
      <b-form autocomplete="false">
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <!-- Loại báo cáo -->
                Report Type
                <span class="text-danger">*</span>
              </template>
              <b-form-select
                v-model="reportKind"
                :options="optionsReport"
                @change="changeReportKind"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="reportKind == 0">
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Assets Type
                <!-- Loại tài sản -->
                <span class="text-danger">*</span>
              </template>
              <multiselect
                v-model="assetType"
                placeholder
                track-by="id"
                label="type"
                selectedLabel="Selecting"
                select-label="Enter to select"
                deselectLabel="Enter to delete"
                :searchable="true"
                :options="assetTypes"
                :taggable="true"
              ></multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-button class="mr-2" variant="info" @click.prevent="selectReport">
                <i class="fas fa-check mr-2"></i>
                Select
                <!-- Chọn -->
              </b-button>
              <b-button class="mr-2" variant="secondary" @click.prevent="closeModal">
                <i class="fas fa-times mr-2"></i>
                Close
                <!-- Đóng -->
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import ReportAssetType from "../components/Asset/ReportAssetType";
import ReportAllAssetType from "../components/Asset/ReportAllAssetType";
import ReportAllAssetTypeByType from "../components/Asset/ReportAllAssetTypeByType";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "AssetsReport",
  components: {
    ReportAssetType,
    ReportAllAssetType,
    ReportAllAssetTypeByType,
    Multiselect,
  },
  data() {
    return {
      optionsReport: [
        { value: 0, text: "Report 01 - Báo cáo theo loại tài sản" },
        { value: 1, text: "Report 02 - Báo cáo tổng thể tài sản" },
        { value: 2, text: "Report 03 - Báo cáo tổng thể theo loại tài sản" },
      ],
      reportKind: null,
      report: null,
      modalShow: false,
      vitricongviecs: [],
      loaihopdongs: [],
      departments: [],
      loaihopdong: null,
      employee: null,
      employees: [],
      assetTypes: [],
      assetType: null,
      tinhtrangtaisans: [],
      rooms: []
    };
  },
  computed: {},
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get("/api/picklist?q=tinhtrangtaisan|vitricongviec"),
        axios.get("/api/department"),
        axios.get("/api/room")
      ])
      .then(
        axios.spread((picklist, department, room) => {
          next((vm) => vm.initData(picklist.data, department.data, room.data));
        })
      );
  },
  //   beforeRouteUpdate(to, from, next) {

  //   },
  methods: {
    initData(picklists, departments, rooms) {
      this.tinhtrangtaisans = picklists.filter(
        (x) => x.pickListType == "tinhtrangtaisan"
      );
      this.vitricongviecs = picklists.filter(
        (x) => x.pickListType == "vitricongviec"
      );
      this.departments = departments;
      this.rooms = rooms;
    },
    openModal() {
      this.modalShow = true;
      this.report = null;
    },
    closeModal() {
      this.modalShow = false;
      this.loaihopdong = null;
    },
    selectReport() {
      if (this.reportKind == 7 &&
          this.employee == null
         ) {
        this.$toast.error("Vui lòng chọn nhân viên", "Lỗi", {
          timeout: 2000,
        });
        return;
      }
      this.report = this.reportKind;
      this.modalShow = false;
    },
    changeReportKind() {
      if (this.reportKind == 0) {
        axios
          .get("/api/assettype")
          .then((response) => {
            this.assetTypes = response.data.items;
            this.assetTypes.sort((a, b) => {
              var type_a = a.type.toLowerCase(), type_b = b.type.toLowerCase();
              if (type_a < type_b) return -1;
              if (type_a > type_b) return 1;

              return 0;
            });
          })
          .catch((err) => {});
      }
    },

    excelReport() {
      let query = Object.assign({}, this.$route.query);
      query.report = this.report;
      if (this.report == 0) query.assetType = this.assetType.id;
      axios({
        method: "get",
        url: `/api/assetreport/report`,
        params: query,
        responseType: "blob", // important
      })
        .then((res) => {
          let filename = res.headers["content-disposition"]
            .split(";")
            .find(function (el) {
              if (el.includes("filename=")) return el;
            })
            .replace("filename=", "")
            .trim();
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          //   reject(err);
        });
      //window.open(`/api/employeereport?report=${this.report}`, "_blank");
      //   axios
      //     .get(`/api/employeereport?report=${this.report}`)
      //     .then((response) => {})
      //     .catch((err) => {
      //       this.$toast.error(err.response.data, "Lỗi", {
      //         timeout: 3000,
      //       });
      //     });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


